import { CASTING_ROLES } from '@lib/utils/constants';

const FULL_BOOKINGS_EXPORT_PERMISSIONS = {
  canViewExportMenu: true,
  canExportGalleryPdf: true,
  canExportSkinsPdf: true,
  canExportCustomCsv: true,
  canExportPayrollCsv: true,
  canExportSagAftraCsv: true,
  canExportBankInfoSpreadsheet: true,
  canExportParamountDriveOnSpreadsheet: true,
};

const LIMITED_BOOKINGS_EXPORT_PERMISSIONS = {
  canViewExportMenu: true,
  canExportGalleryPdf: true,
  canExportSkinsPdf: true,
  canExportCustomCsv: true,
  canExportPayrollCsv: false,
  canExportSagAftraCsv: false,
  canExportBankInfoSpreadsheet: false,
  canExportParamountDriveOnSpreadsheet: false,
};

const FULL_LIST_TABLE_PERMISSIONS = {
  canView: true,
  canEditProjectInfo: true,
  canEditNotes: true,
  canEditCells: true,
  canViewAddBGMenu: true,
  canViewMsgStatusMenu: true,
  canViewEditMenu: true,
  canViewGalleryMenu: true,
  canCreateGallery: true,
  canViewApplicationsMenu: true,
  canEditPhotos: true,
};

const FULL_BOOKINGS_BASE_PERMISSIONS = {
  canView: true,
  canEditProjectInfo: true,
  canEditNotes: true,
  canEditCells: true,
  canViewAddBGMenu: true,
  canViewMsgStatusMenu: true,
  canViewEditMenu: true,
  canViewRoleBreakdownMenu: true,
  canViewColumnFilterMenu: true,
  canViewFilterSelectedMenu: true,
  canViewOnboardToPayrollBtn: true,
  canEditPhotos: true,
};

const FULL_USER_MODAL_PERMISSIONS = {
  canEditAppearance: true,
  canEditMeasurements: true,
  canMakeProfilePhoto: true,
  canEditPhotos: true,
  canDeletePhotos: true,
  canEditSkills: true,
  canEditProps: true,
  canEditWardrobe: true,
  canEditTransportation: true,
  canEditRTW: true,
  canEditDBS: true,
  canViewJobHistoryMessage: true,
  canViewReviews: true,
  canLeaveReviews: true,
  canDeleteReviews: true,
  canViewGeneral: true,
};

export const FEATURE_PERMISSIONS_PER_ROLE: RolePermissions = {
  [CASTING_ROLES.Admin]: {
    // COMPANY PAGE
    company: {
      canView: true,
      canEdit: true,
    },
    // TEAMS PAGE
    teams: {
      canView: true,
      canEdit: true,
      canChangeAccess: true,
      canAddToTeams: true,
    },
    // ACCOUNTS SETTINGS PAGE
    accounts: {
      canView: true,
      canEdit: true,
      canViewSideMenu: true,
    },
    // COMPANY INFO PAGE
    companyInfo: {
      canView: true,
      canEdit: true,
    },
    // EXPLORE PAGE
    explore: {
      canView: true,
    },
    // PROJECTS PAGE
    projects: {
      canView: true,
      canDelete: true,
      canEdit: true,
      canAdd: true,
    },
    // PROJECT DASHBOARD PAGE
    projectDashboard: {
      canView: true,
      canEdit: true,
      canEditProjectInfo: true,
      canEditProjectSettings: true,
      canViewNotifications: true,
      canEditNotifications: true,
      canViewRates: true,
      canEditRates: true,
    },
    // LIST PAGE
    list: {
      canView: true,
      canAdd: true,
      canArchive: true,
      canMakeFave: true,
    },
    // LIST TABLE PAGE
    listTable: {
      ...FULL_LIST_TABLE_PERMISSIONS,
    },
    // BOOKINGS PAGE
    bookings: {
      ...FULL_BOOKINGS_BASE_PERMISSIONS,
      ...FULL_BOOKINGS_EXPORT_PERMISSIONS,
    },
    // USER MODAL
    userModal: {
      ...FULL_USER_MODAL_PERMISSIONS,
      canImpersonate: true,
      canDeactivate: true,
    },
  },

  [CASTING_ROLES.Manager]: {
    // COMPANY PAGE
    company: {
      canView: false,
      canEdit: false,
    },
    // TEAMS PAGE
    teams: {
      canView: true,
      canEdit: true,
      canChangeAccess: true,
      canAddToTeams: true,
    },
    // ACCOUNTS SETTINGS PAGE
    accounts: {
      canView: true,
      canEdit: true,
      canViewSideMenu: true,
    },
    // COMPANY INFO PAGE
    companyInfo: {
      canView: false,
      canEdit: false,
    },
    // EXPLORE PAGE
    explore: {
      canView: true,
    },
    // PROJECTS PAGE
    projects: {
      canView: true,
      canDelete: true,
      canEdit: true,
      canAdd: true,
    },
    // PROJECT DASHBOARD PAGE
    projectDashboard: {
      canView: true,
      canEdit: true,
      canEditProjectInfo: true,
      canEditProjectSettings: true,
      canViewNotifications: true,
      canEditNotifications: true,
      canViewRates: true,
      canEditRates: true,
    },
    // LIST PAGE
    list: {
      canView: true,
      canAdd: true,
      canArchive: true,
      canMakeFave: true,
    },
    // LIST TABLE PAGE
    listTable: {
      ...FULL_LIST_TABLE_PERMISSIONS,
    },
    // BOOKINGS PAGE
    bookings: {
      ...FULL_BOOKINGS_BASE_PERMISSIONS,
      ...FULL_BOOKINGS_EXPORT_PERMISSIONS,
    },
    // USER MODAL
    userModal: {
      ...FULL_USER_MODAL_PERMISSIONS,
      canImpersonate: false,
      canDeactivate: true,
    },
  },

  [CASTING_ROLES.Casting]: {
    // COMPANY PAGE
    company: {
      canView: false,
      canEdit: false,
    },
    // TEAMS PAGE
    teams: {
      canView: false,
      canEdit: false,
      canChangeAccess: false,
      canAddToTeams: false,
    },
    // ACCOUNTS SETTINGS PAGE
    accounts: {
      canView: true,
      canEdit: true,
      canViewSideMenu: false,
    },
    // COMPANY INFO PAGE
    companyInfo: {
      canView: false,
      canEdit: false,
    },
    // EXPLORE PAGE
    explore: {
      canView: true,
    },
    // PROJECTS PAGE
    projects: {
      canView: true,
      canDelete: false,
      canEdit: true,
      canAdd: false,
    },
    // PROJECT DASHBOARD PAGE
    projectDashboard: {
      canView: true,
      canEdit: true,
      canEditProjectInfo: true,
      canEditProjectSettings: true,
      canViewNotifications: true,
      canEditNotifications: true,
      canViewRates: true,
      canEditRates: true,
    },
    // LIST PAGE
    list: {
      canView: true,
      canAdd: true,
      canArchive: true,
      canMakeFave: true,
    },
    // LIST TABLE PAGE
    listTable: {
      ...FULL_LIST_TABLE_PERMISSIONS,
    },
    // BOOKINGS PAGE
    bookings: {
      ...FULL_BOOKINGS_BASE_PERMISSIONS,
      ...FULL_BOOKINGS_EXPORT_PERMISSIONS,
    },
    // USER MODAL
    userModal: {
      ...FULL_USER_MODAL_PERMISSIONS,
      canDeleteReviews: false,
      canImpersonate: false,
      canDeactivate: false,
    },
  },

  [CASTING_ROLES.Basic]: {
    // COMPANY PAGE
    company: {
      canView: false,
      canEdit: false,
    },
    // TEAMS PAGE
    teams: {
      canView: false,
      canEdit: false,
      canChangeAccess: false,
      canAddToTeams: false,
    },
    // ACCOUNTS SETTINGS PAGE
    accounts: {
      canView: true,
      canEdit: true,
      canViewSideMenu: false,
    },
    // COMPANY INFO PAGE
    companyInfo: {
      canView: false,
      canEdit: false,
    },
    // EXPLORE PAGE
    explore: {
      canView: false,
    },
    // PROJECTS PAGE
    projects: {
      canView: true,
      canDelete: false,
      canEdit: false,
      canAdd: false,
    },
    // PROJECT DASHBOARD PAGE
    projectDashboard: {
      canView: true,
      canEdit: false,
      canEditProjectInfo: false,
      canEditProjectSettings: false,
      canViewNotifications: false,
      canEditNotifications: false,
      canViewRates: false,
      canEditRates: false,
    },
    // LIST PAGE
    list: {
      canView: true,
      canAdd: false,
      canArchive: false,
      canMakeFave: false,
    },
    // LIST TABLE PAGE
    listTable: {
      canView: true,
      canEditProjectInfo: false,
      canEditNotes: false,
      canEditCells: false,
      canViewAddBGMenu: false,
      canViewMsgStatusMenu: false,
      canViewEditMenu: false,
      canViewGalleryMenu: true,
      canCreateGallery: false,
      canViewApplicationsMenu: false,
      canEditPhotos: false,
    },
    // BOOKINGS PAGE
    bookings: {
      canView: true,
      canEditProjectInfo: false,
      canEditNotes: false,
      canEditCells: false,
      canViewAddBGMenu: false,
      canViewMsgStatusMenu: false,
      canViewEditMenu: false,
      canViewRoleBreakdownMenu: false,
      canViewColumnFilterMenu: true,
      canViewFilterSelectedMenu: false,
      canViewOnboardToPayrollBtn: false,
      canEditPhotos: false,
      ...LIMITED_BOOKINGS_EXPORT_PERMISSIONS,
    },
    // USER MODAL
    userModal: {
      canEditAppearance: false,
      canEditMeasurements: false,
      canMakeProfilePhoto: false,
      canEditPhotos: false,
      canDeletePhotos: false,
      canEditSkills: false,
      canEditProps: false,
      canEditWardrobe: false,
      canEditTransportation: false,
      canEditRTW: false,
      canEditDBS: false,
      canViewJobHistoryMessage: false,
      canViewReviews: false,
      canLeaveReviews: false,
      canDeleteReviews: false,
      canViewGeneral: false,
      canImpersonate: false,
      canDeactivate: false,
    },
  },
};
